import {IHttpPromise, IHttpResponse, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Brand} from "../model/Brand";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";

export class BrandService {

    public static instance = ['$http', ToastNotificationServiceName, BrandService];


    constructor(private $http: IHttpService,
                private notificationService: ToastNotificationService) {

    }

    public updateBrandLogo = (brandId, logoImageId) =>
        this.$http({
            method: 'PUT',
            url: getAbsoluteUrl(`api/brand/${brandId}`),
            data: {
                image_id: logoImageId
            }
        });

    public getBrands = (): IHttpPromise<Brand[]> =>
        this.$http({
            url: getAbsoluteUrl('api/brand'),
            method: 'GET',
            params: {
                'full_view': false,
                'only_allowed': true
            }
        });

    public updateBrand = (brand) => this.$http({
        method: 'PUT',
        url: getAbsoluteUrl('api/brand'),
        data: brand
    }).then(
        (resp: IHttpResponse<Brand>) => resp.data,
        () => this.notificationService.generateErrorMessage("AccessLevelBrand wasn't updated")
    );

    public saveBrand = (brand) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/brand'),
        data: brand
    }).then(
        (resp: IHttpResponse<Brand>) => {
            return resp.data;
        }
    );

    public deleteBrand = (brand: Brand) => {
        return this.$http({
            method: 'DELETE',
            data: brand,
            url: getAbsoluteUrl('api/brand')
        });
    };

    public getBrandsLogos = (): IHttpPromise<BrandLogoDto[]> => this.$http({
        method: 'GET',
        url: getAbsoluteUrl('api/brand'),
        params: {
            format_logos: true
        }

    });

}